export const enum designType {
  Primary = 'primary',
  Secondary = 'secondary',
  Tertiary = 'tertiary',
  Unselected = 'unselected',
  Default = 'default',
  Action = 'action',
  Link = 'link',
}
